import { Button, Col, Row } from "react-bootstrap"
import { deepGet, upgradedDeepGet } from "../../../features/dataFunctions/dataFunctions"
import { useNavigate, useParams } from "react-router-dom"
import { getItemWebStorage } from "../../../features/webStorageSaver"

const square_check = require('../../../assets/images/fontAwesomeIcons/square-check-regular.svg').default
const square_cross = require('../../../assets/images/fontAwesomeIcons/square-xmark-solid.svg').default

export default function CustomObjectInfoCardSection({ sectionName, sectionFields, sectionButtons, objectInfo }: any) {
    const { id, objectType, entityId }: any = useParams()
    const navigate = useNavigate()
    return (
        <>
            <Row>
                <div className="section-name">{sectionName}</div>
            </Row>
            <Row xs={1} md={3} lg={5}>
                {sectionFields && sectionFields.map((fieldOptions: any) => {
                    const { caption, field, valueType, enumObject } = fieldOptions
                    let fieldNameSuperText, valueSuperText = false
                    let beforeFieldNameSup, fieldNameSup, beforeValueSup, valueSup
                    let value: any = upgradedDeepGet(objectInfo, field)
                    if (valueType === "enum") {
                        value = enumObject?.[value]
                    }
                    // Обработчик наличия superscript текста
                    if (value) {
                        if (value?.toString().indexOf('<sup>') !== -1) {
                            const parts = value.split(/<sup>|<\/sup>/);
                            beforeValueSup = parts[0]; // Текст до <sup>
                            valueSup = parts[1]; // Текст между <sup> и </sup>
                            valueSuperText = true
                        }
                    }
                    if (caption) {
                        if (caption?.toString().indexOf('<sup>') !== -1) {
                            const parts = caption.split(/<sup>|<\/sup>/);
                            beforeFieldNameSup = parts[0]; // Текст до <sup>
                            fieldNameSup = parts[1]; // Текст между <sup> и </sup>
                            fieldNameSuperText = true
                        }
                    }
                    return (
                        <>
                            {/* два варианта отображения названия поля: при наличии superscript / без superscript */}
                            {fieldNameSuperText
                                ?
                                <Col className="field">{beforeFieldNameSup}<sup>{fieldNameSup}</sup></Col>
                                :
                                <Col className="field">{caption}</Col>
                            }
                            {/* два варианта отображения значения: при наличии superscript / без superscript */}
                            {valueSuperText
                                ?
                                <Col className="value">{beforeValueSup}<sup>{valueSup}</sup></Col>
                                :
                                <>
                                    {typeof value === 'boolean' &&
                                        <>
                                            {value === true &&
                                                <Col className="value">
                                                    <img src={square_check} alt="true" />
                                                </Col>
                                            }
                                            {value === false &&
                                                <Col className="value">
                                                    <img src={square_cross} alt="false" />
                                                </Col>
                                            }
                                        </>
                                    }
                                    {typeof value !== 'boolean' &&
                                        <Col className={"value" + (value ? " basic-info-value" : " basic-info-no-value")}>{value ?? 'Не указано'}</Col>
                                    }
                                </>
                            }
                        </>
                    )
                })}
                {sectionButtons && Object.entries(sectionButtons).map(([buttonName, buttonOptions]: any) => {
                    const { caption, propertyForEnabledCheck: propertyName, onClick } = buttonOptions ?? {}
                    let valueForCheck = propertyName.includes('.') ? deepGet(objectInfo, propertyName.split('.')) : objectInfo[propertyName]
                    let buttonIsEnabled = typeof valueForCheck === typeof [] ? valueForCheck.length > 0 : valueForCheck
                    let { type, url } = onClick ?? {}
                    let onClickFunction = () => { }
                    if (type === 'redirect.documents') {
                        url = url.replace(':id', `${id}`)
                        url = url.replace(':objectType', `${objectType}`)
                        url = url.replace(':entityId', `${entityId}`)
                        onClickFunction = () => navigate(`/app/${url}`)
                    }
                    if (type === 'redirect.nestedTable') {
                        const currentConfig = getItemWebStorage('currentConfig')
                        const { tableAdditionalItems } = currentConfig
                        const tableAdditionalItem = tableAdditionalItems.find((item: any) => item?.id === id)
                        const { nestedTable } = tableAdditionalItem ?? {}
                        const nestedObjectType = nestedTable?.objectType
                        url = url.replace(':id', `${id}`)
                        url = url.replace(':objectType', `${objectType}`)
                        url = url.replace(':entityId', `${entityId}`)
                        url = url.replace(':nestedObjectType', `${nestedObjectType}`)
                        onClickFunction = () => navigate(`/app/${url}`)
                    }
                    return (
                        <>
                            <Col className="field">
                                <Button disabled={!buttonIsEnabled} onClick={onClickFunction} className={'card-button' + (buttonIsEnabled ? '' : ' disabled')}>
                                    <span>{caption}</span>
                                </Button>
                            </Col>
                            <Col className="value-template"></Col>
                        </>
                    )
                })}
            </Row>
        </>
    )
}
